import request from '@/utils/request';

export function listTransDetail(data) {
  return request({
    url: '/trans/listTransDetail',
    method: 'post',
    data,
  });
}

export function listAllTransToolByMerchantId(params) {
  return request({
    url: '/transTool/listAllTransToolByMerchantId',
    method: 'get',
    params,
  });
}

export function fetchCashiers(data) {
  return request({
    url: '/merchant-info/listCashierArea',
    method: 'post',
    data,
  });
}
